module.exports = __webpack_public_path__ + "img/25.d87c19d8.svg";